<template>
<div>
	<div class="row-fluid">
		<div class="row">
			<div class="col-6">
				 <el-radio v-model="radio" label="1">备选项</el-radio>
				  <el-radio v-model="radio" label="2">备选项</el-radio>
			</div>
			<div class="col-6">
				<el-progress type="circle" :percentage="0"></el-progress>
				<el-progress type="circle" :percentage="25"></el-progress>
				<el-progress type="circle" :percentage="100" status="success"></el-progress>
				<el-progress type="circle" :percentage="71" status="warning"></el-progress>
				<el-progress type="circle" :percentage="50" status="exception"></el-progress>
			</div>
		</div>
		
		<div class="row">
			<div class="col-6">
				 <el-button :plain="true" @click="open">打开消息提示</el-button>
				  <el-button :plain="true" @click="openVn">VNode</el-button>
			</div>
			<div class="col-6">
				<el-row>
				  <el-col :span="24"><div class="grid-content bg-purple-dark">2</div></el-col>
				</el-row>
				<el-row>
				  <el-col :span="12"><div class="grid-content bg-purple">3</div></el-col>
				  <el-col :span="12"><div class="grid-content bg-purple-light">4</div></el-col>
				</el-row>
				<el-row>
				  <el-col :span="8"><div class="grid-content bg-purple">5</div></el-col>
				  <el-col :span="8"><div class="grid-content bg-purple-light">6</div></el-col>
				  <el-col :span="8"><div class="grid-content bg-purple">7</div></el-col>
				</el-row>
				<el-row>
				  <el-col :span="6"><div class="grid-content bg-purple">8</div></el-col>
				  <el-col :span="6"><div class="grid-content bg-purple-light">99</div></el-col>
				  <el-col :span="6"><div class="grid-content bg-purple">11</div></el-col>
				  <el-col :span="6"><div class="grid-content bg-purple-light">22</div></el-col>
				</el-row>
				<el-row>
				  <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
				  <el-col :span="4"><div class="grid-content bg-purple-light"></div></el-col>
				  <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
				  <el-col :span="4"><div class="grid-content bg-purple-light"></div></el-col>
				  <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
				  <el-col :span="4"><div class="grid-content bg-purple-light"></div></el-col>
				</el-row>

			</div>
		</div>
		
		<Tabbar></Tabbar>
	</div>

</div>
</template>

<script>
	import Tabbar from '../../sub/tabbar'
  export default {
	  components: {
	  	Tabbar
	  },
	  data() {
	  	return {}
	  },
      methods: {
        open() {
          this.$message('这是一条消息提示');
        },
  
        openVn() {
          const h = this.$createElement;
          this.$message({
            message: h('p', null, [
              h('span', null, '内容可以是 '),
              h('i', { style: 'color: teal' }, 'VNode')
            ])
          });
        }
      }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/views/web/index.vue